import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { LiveUserAuthority } from 'src/lib/entity/live-user-authority'
import { ActivatedRoute } from '@angular/router'
import { FirestoreAccess } from 'src/lib/firestore-access'
import {
  OrderResRouteParams,
  OrderMeta,
  OrderStatus,
} from 'src/lib/entity/order'
import { ConsoleLogger } from 'src/lib/console-logger'
import {
  Gift,
  NoticeModalProperties,
  SendGiftRequest,
  UsersOwnedPoint,
} from 'src/lib/entity/gift-point'
import { map } from 'rxjs/operators'
import { environment } from 'src/env/environment'
import { Mag2UserProfile } from 'src/lib/entity/mag2-user'
import { Subscription } from 'rxjs'
import { CookieService } from 'ngx-cookie-service'
import { Location } from '@angular/common'

@Component({
  selector: 'maglive-gift-comment',
  templateUrl: './gift-comment.component.html',
  styleUrls: ['./gift-comment.component.scss'],
})
export class GiftCommentComponent implements OnInit, OnDestroy {
  /* Subscription */
  private getUserProfileSub: Subscription | undefined
  private queryParamsSub: Subscription | undefined
  private getGiftsSub: Subscription | undefined
  private getOrderStatusSub: Subscription | undefined
  private getAuthoritySub: Subscription | undefined
  private sendGiftSub: Subscription | undefined

  selectedGift: Gift | null = null
  isOpenQuestionModal = false
  isOpenChargeModal = false
  isOpenUpdateNicknameModal = false

  private orderStatus: OrderStatus
  isShowSpinner = false
  usersOwnedPoint: UsersOwnedPoint
  gifts: Gift[]
  url = environment.baseURL.mag2mypage
  env = environment.name
  private userProfile: Mag2UserProfile
  private isSkipNicknameUpdateProcess = false
  isProcessingUpdateNickname: boolean
  lackPoint: number | undefined
  selectedGiftPoint: number | undefined
  noticeModalProp1: NoticeModalProperties = {
    isOpenNoticeModal: false,
    title: 'ポイントが不足しています',
    description: 'チャージしますか？',
    isShowCheckbox: false,
    acceptBtnTxt: 'チャージ',
  }
  noticeModalProp2: NoticeModalProperties = {
    isOpenNoticeModal: false,
    title: 'このギフトを送信します',
    description: 'よろしいでしょうか？',
    isShowCheckbox: true,
    acceptBtnTxt: '送信',
  }
  // ギフト送信確認モーダルの表示設定をcookieに保存する
  isShowConfirmModal: boolean
  private cookieKey: string
  // 有効期限の日数指定の場合は、numberを指定する。日時指定の場合は、Dateを指定
  private EXPIRE_DAY = 365

  @Input() isShowGiftComponent: boolean
  @Input() isShowGiftConfirmComponent: boolean
  @Input() isScreenRotated: boolean
  @Input() authority: LiveUserAuthority
  @Input() liveId: string
  @Output() showGiftControlEvent = new EventEmitter<boolean | void>()
  @Output() showGiftConfirmControlEvent = new EventEmitter<boolean | void>()

  constructor(
    private route: ActivatedRoute,
    private firestoreAccess: FirestoreAccess,
    private logger: ConsoleLogger,
    private cookieService: CookieService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.getAuthoritySub = MagliveApiClient.getAuthority().subscribe(
      (authorities) => {
        this.usersOwnedPoint = authorities.ownedPoint
      }
    )
    this.getUserProfileSub = MagliveApiClient.getUserProfile(
      this.authority.userId
    ).subscribe((value) => {
      if (value !== 'NOT_AUTHORIZED' && value !== 'NOT_FOUND') {
        this.userProfile = value
        this.logger.info(
          this.constructor.name,
          'getUserProfile',
          'userProfile',
          this.userProfile
        )
      }
    })
    this.getGiftsSub = this.firestoreAccess.getGifts().subscribe((value) => {
      this.gifts = value
    })

    // ポイントチャージ後のcallbackUrlで表示された場合の挙動
    this.queryParamsSub = this.route.queryParams.subscribe(
      (params: OrderResRouteParams) => {
        this.logger.info(
          this.constructor.name,
          'ngOnInit',
          'routeParams',
          params
        )
        // ordersのstatusを監視 (処理中表示のコントロール用)
        if (params.success !== undefined && params.orderId !== undefined) {
          this.getOrderStatusSub = this.firestoreAccess
            .getOrderStatus(params.orderId)
            .subscribe((value: OrderMeta[]) => {
              this.orderStatus = value[0].status
              this.checkShowSpinner()
              this.logger.info(
                this.constructor.name,
                'ngOnInit',
                'orderStatus',
                this.orderStatus
              )
            })
        }
      }
    )

    this.cookieKey = 'isShowConfirmModal' + this.authority.userId
    if (this.cookieService.check(this.cookieKey)) {
      this.isShowConfirmModal = this.toBoolean(
        this.cookieService.get(this.cookieKey)
      )
    } else {
      this.isShowConfirmModal = true
    }
  }

  ngOnDestroy(): void {
    if (this.getUserProfileSub) {
      this.getUserProfileSub.unsubscribe()
    }
    if (this.queryParamsSub) {
      this.queryParamsSub.unsubscribe()
    }
    if (this.getGiftsSub) {
      this.getGiftsSub.unsubscribe()
    }
    if (this.getOrderStatusSub) {
      this.getOrderStatusSub.unsubscribe()
    }
    if (this.getAuthoritySub) {
      this.getAuthoritySub.unsubscribe()
    }
    if (this.sendGiftSub) {
      this.sendGiftSub.unsubscribe()
    }
  }

  /**
   * 処理中 (クルクル) の表示出し分け
   */
  private checkShowSpinner() {
    if (
      this.orderStatus !== undefined &&
      this.orderStatus !== 'COMPLETED' &&
      this.orderStatus !== 'FAILED'
    ) {
      this.logger.message(
        this.constructor.name,
        'checkShowSpinner',
        'order status is processing...'
      )
      this.isShowSpinner = true

    } else if (this.orderStatus === 'COMPLETED') {
      // 所持ポイントをアップデート
      this.getAuthoritySub = MagliveApiClient.getAuthority().subscribe(
        (authorities) => {
          this.usersOwnedPoint = authorities.ownedPoint
          this.logger.message(
            this.constructor.name,
            'checkShowSpinner',
            'Users owned point updated.'
          )
          this.location.replaceState('lives/' + this.liveId)
          if (alert('チャージ完了しました') === undefined) {
            this.orderStatus = undefined
            window.location.reload()
            return
          }
        }
      )
      this.isShowSpinner = false
    } else {
      this.logger.message(
        this.constructor.name,
        'checkShowSpinner',
        'order status is fixed'
      )
      this.isShowSpinner = false
    }
  }

  /**
   * アイコンが選択された時の表示切り替え
   * 2回同じアイコンがクリックされたら送信処理
   */
  selectGift(gift: Gift): void {
    if (!this.isEnoughPoint(gift)) {
      this.logger.message(this.constructor.name, 'selectGift', 'lack of point')
      this.toggleLackPointModal()
      return
    }
    // ダブルクリック時
    if (this.selectedGift === gift) {
      // TODO: ニックネーム登録導線は1クリック目なのか確認する
      if (!this.userProfile.nickname && !this.isSkipNicknameUpdateProcess) {
        // ニックネーム未登録の場合は登録の導線を表示
        this.logger.message(
          this.constructor.name,
          'selectGift',
          'User have not nickname'
        )
        // 配信中の画面に戻る
        this.openAndCloseUpdateNicknameModal()
      } else if (
        this.userProfile.nickname ||
        this.isSkipNicknameUpdateProcess
      ) {
        if (this.isShowConfirmModal) {
          this.toggleConfirmModal()
        } else {
          this.sendGift(!this.isShowConfirmModal)
        }
      }
    } else {
      this.selectedGift = gift
    }
  }

  /**
   * モーダルの開閉
   */
  toggleLackPointModal(): void {
    this.noticeModalProp1.isOpenNoticeModal =
      !this.noticeModalProp1.isOpenNoticeModal
  }

  toggleConfirmModal(): void {
    this.noticeModalProp2.isOpenNoticeModal =
      !this.noticeModalProp2.isOpenNoticeModal
  }

  /**
   * ギフト送信を行う
   */
  sendGift(isNotShowConfirm: boolean) {
    const request: SendGiftRequest = {
      giftId: this.selectedGift.id,
      giftQuantity: 1,
      message: null,
      device: {
        os: 'web',
        version: '1.0.0',
        model: 'chrome',
        appVersion: '1.0.0',
      },
    }
    this.logger.info(this.constructor.name, 'sendGift', 'request', request)
    this.sendGiftSub = MagliveApiClient.sendGift(this.liveId, request)
      .pipe(
        map((x) => {
          if (x === 'ENTITY_TOO_LARGE') {
            alert('入力されたコメントが長すぎます。')
            return
          }
          if (x === 'UNACCEPTABLE_CONTENT') {
            alert('投稿できない内容が含まれています。')
            return
          }
        })
      )
      .subscribe(
        (_) => {
          this.getAuthoritySub = MagliveApiClient.getAuthority().subscribe(
            (authorities) => {
              this.authority = authorities
              this.usersOwnedPoint = authorities.ownedPoint
            }
          )
          this.selectedGift = null
          this.isSkipNicknameUpdateProcess = false
          this.closeInputComponent()
        },
        (error) => {
          console.error(error)
        }
      )
    this.saveConfirmShowSetting(isNotShowConfirm)
    this.showGiftControlEvent.emit()
  }

  /**
   * ポイントが足りているか判定する
   */
  private isEnoughPoint(gift: Gift): boolean {
    const isEnough = this.usersOwnedPoint.totalPoint >= gift.point
    if (isEnough) {
      this.lackPoint = undefined
      this.selectedGiftPoint = undefined
    } else {
      this.lackPoint = gift.point - this.usersOwnedPoint.totalPoint
      this.selectedGiftPoint = gift.point
    }
    return isEnough
  }

  /**
   * 投げ銭時に確認画面を表示するかの設定を保存する
   */
  saveConfirmShowSetting(isNotShow: boolean) {
    this.isShowConfirmModal = !isNotShow
    const value = this.isShowConfirmModal.toString()
    this.cookieService.set(this.cookieKey, value, { expires: this.EXPIRE_DAY })
    if (this.cookieService.check(this.cookieKey)) {
      const temp = this.toBoolean(this.cookieService.get(this.cookieKey))
      this.logger.info(
        this.constructor.name,
        'saveConfirmShowSetting',
        'cookie',
        temp
      )
    }
  }

  private toBoolean(data) {
    return data.toLowerCase() === 'true'
  }

  /**
   * 閉じるボタンの挙動
   */
  closeInputComponent() {
    this.showGiftControlEvent.emit(false)
  }

  /**
   * ギフトとは？のモーダルを開閉する
   */
  openQuestionModal() {
    this.isOpenQuestionModal = !this.isOpenQuestionModal
  }

  /**
   * ニックネーム登録モーダルの開閉
   * isSkip : ニックネームモーダルのスキップボタンが押下された場合に使用
   */
  openAndCloseUpdateNicknameModal(isSkip?: boolean) {
    this.getUserProfileSub = MagliveApiClient.getUserProfile(
      this.authority.userId
    ).subscribe((value) => {
      if (value !== 'NOT_AUTHORIZED' && value !== 'NOT_FOUND') {
        this.userProfile = value
        this.logger.info(
          this.constructor.name,
          'getUserProfile',
          'userProfile',
          this.userProfile
        )
      }
    })
    // ニックネームが登録されていたら何もしない
    if (this.userProfile.nickname) return
    if (isSkip) {
      this.isSkipNicknameUpdateProcess = true
      this.isOpenUpdateNicknameModal = !this.isOpenUpdateNicknameModal
    } else {
      this.isOpenUpdateNicknameModal = !this.isOpenUpdateNicknameModal
    }
  }

  /**
   * ポイントチャージのモーダルを開閉する
   */
  openChargeModal(isFromGiftModal: boolean | undefined) {
    if (isFromGiftModal) {
      this.lackPoint = undefined
      this.selectedGiftPoint = undefined
    }
    this.isOpenChargeModal = !this.isOpenChargeModal
  }

  /**
   * ローカル確認用
   */
  getGiftIconPath(iconPath: string) {
    if (this.env === 'local') {
      return `/assets/animations${iconPath}`
    } else {
      return iconPath
    }
  }
}
